export default __webpack_public_path__ + "static/media/green-leaf.5a68bb72.svg";